/**
 * Met en pause les rafraichissements d'ecran quand une fenetre est ouverte
 * (boussole, lecture de document, signature, scan).
 * Les envois continuent en arriere-plan, mais l'affichage ne bouge plus :
 * sans cela, un envoi de photo refermerait ce que le technicien a sous les yeux.
 */

let compteur = 0;
let enAttente = [];

export const ouvrirFenetre = () => {
  compteur += 1;
};

export const fermerFenetre = () => {
  compteur = Math.max(0, compteur - 1);
  if (compteur === 0 && enAttente.length) {
    const files = [...enAttente];
    enAttente = [];
    files.forEach((f) => { try { f(); } catch (e) {} });
  }
};

export const estEnPause = () => compteur > 0;

/** Execute maintenant, ou a la fermeture de la derniere fenetre. */
export const quandLibre = (action) => {
  if (compteur === 0) return action();
  if (!enAttente.includes(action)) enAttente.push(action);
};
